import styled from "styled-components";
import Link from "@mui/material/Link";

export const Title = styled.div`
  font-family: Manrope;
  font-size: 24px;
  font-weight: 800;
  line-height: 34px;
  letter-spacing: 0em;
  text-align: left;
  margin: 32px 0;

  @media (max-width: 1000px) {
    padding: 0 16px;
    margin: 16px 0;
  }
`;
export const FastLink = styled(Link)<{ $current?: boolean }>`
  && {
    text-decoration: none;
    font-family: Manrope;
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 0em;
    text-align: left;
    color: ${(props) =>
      props.$current ? "rgba(191, 195, 200, 1)" : "rgba(5, 115, 228, 1)"};
  }
`;

export const FastTab = styled.span`
  font-family: Manrope;
  font-size: 14px;
  font-weight: 800;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
`;
